module.exports = __webpack_public_path__ + "static/media/bluePhoto.964050d4.jpg";